import { apiGet, apiPost } from "@/services/api/httpClient";
import { apiBaseUrl } from "@/services/api/httpClient";
import { ApiRequestError } from "@/services/api/httpClient";
import type { AuthUser, LoginPayload, RegisterPayload } from "@/types/auth";

export function registerUser(payload: RegisterPayload): Promise<AuthUser> {
  return apiPost<AuthUser>("/auth/register", payload);
}

export function loginUser(payload: LoginPayload): Promise<AuthUser> {
  return apiPost<AuthUser>("/auth/login", payload);
}

export function fetchCurrentUser(): Promise<AuthUser> {
  return apiGet<AuthUser>("/auth/me");
}

export function logoutUser(): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>("/auth/logout", {});
}

export async function updateProfile(displayName: string): Promise<AuthUser> {
  const response = await fetch(`${apiBaseUrl}/auth/profile`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ displayName })
  });
  if (!response.ok) {
    let message = `请求失败（${response.status}）`;
    try {
      const payload = await response.json();
      message = payload.error?.message || message;
    } catch { /* keep default */ }
    throw new ApiRequestError(message, response.status);
  }
  const payload = await response.json();
  return payload.data;
}

export async function uploadAvatar(file: File): Promise<AuthUser> {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(`${apiBaseUrl}/auth/avatar`, {
    method: "POST",
    credentials: "include",
    body: formData
  });
  if (!response.ok) {
    let message = `请求失败（${response.status}）`;
    try {
      const payload = await response.json();
      message = payload.error?.message || message;
    } catch { /* keep default */ }
    throw new ApiRequestError(message, response.status);
  }
  const payload = await response.json();
  return payload.data;
}
